/**
 * @license @tabler/icons-react v3.36.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

const __iconNode = [["path", { "d": "M7 10h14l-4 -4", "key": "svg-0" }], ["path", { "d": "M17 14h-14l4 4", "key": "svg-1" }]];
const IconArrowsExchange = createReactComponent("outline", "arrows-exchange", "ArrowsExchange", __iconNode);

export { __iconNode, IconArrowsExchange as default };
//# sourceMappingURL=IconArrowsExchange.mjs.map
